import Rx from 'rxjs/Rx';
import { eq, flow, get } from 'lodash/fp';

export const forCollectionName = collectionName =>
  flow(get('collectionName'), eq(collectionName));

export const error$ = e => {
  console.log(e);
  return Rx.Observable.of({ type: 'NOTHING' });
};



// WEBPACK FOOTER //
// ./src/epics/util.js